import { OPENAI_ADS_API } from '@/shared/api/openAiAds';
import { getOpenAiAdsContext } from '@/shared/lib/openAiAdsContext';
import { User } from '@/shared/types/User';

import { useSyncAdsContext } from './useSyncAdsContext';

export const useSyncOpenAiAdsContext = (user?: User) => {
  useSyncAdsContext(user?.id, getOpenAiAdsContext, OPENAI_ADS_API.saveContext);
};
